import React from 'react'

const NoAccess = () => {
    return <div className="mb-h1">You do not have access to view this page.</div>
}

export default NoAccess
